var exports = {
  "kJ": "ThemeEmbed.module__iconCircle___c3c2V1",
  "SP": "ThemeEmbed.module__iconCircleActive___c3c2V1",
  "GP": "ThemeEmbed.module__iconOnBrand___c3c2V1",
};

module.exports = exports;
